import axios from "axios";
import { safeGetFromLocalStorage } from "../helper-functions/safeJSONParse";
export const baseUrl = process.env.REACT_APP_BASE_URL || "https://admin.alot263.com";
const MainApi = axios.create({
  baseURL: baseUrl,
});
MainApi.interceptors.request.use(function (config) {
  let zoneid = undefined;
  let token = undefined;
  let language = undefined;
  let currentLocation = undefined;
  let software_id = 33571750;
  // hostname variable removed as it's no longer needed
  let moduleid = undefined;

  if (typeof window !== "undefined") {
    zoneid = localStorage.getItem("zoneid");
    token = localStorage.getItem("token");
    language = safeGetFromLocalStorage("language-setting", undefined);
    currentLocation = safeGetFromLocalStorage("currentLatLng", undefined);
    const moduleObj = safeGetFromLocalStorage("module", undefined);
    moduleid = moduleObj?.id;
  }
  if (currentLocation) config.headers.latitude = currentLocation.lat;
  if (currentLocation) config.headers.longitude = currentLocation.lng;
  if (zoneid) config.headers.zoneid = zoneid;
  if (moduleid) config.headers.moduleId = moduleid;
  if (token) config.headers.authorization = `Bearer ${token}`;
  if (language) config.headers["X-localization"] = language;
  // Removed manual origin header setting as it's unsafe and automatically handled by browser
  config.headers["X-software-id"] = software_id;
  config.headers["Accept"] = 'application/json'
  return config;
});

// Response interceptor to handle 429 errors with retry logic
MainApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 429 && !originalRequest._retry) {
      originalRequest._retry = true;
      originalRequest._retryCount = (originalRequest._retryCount || 0) + 1;
      
      // Maximum 3 retries
      if (originalRequest._retryCount <= 3) {
        // Exponential backoff: 1s, 2s, 4s
        const delay = Math.pow(2, originalRequest._retryCount - 1) * 1000;
        
        console.warn(
          `Rate limit hit for ${originalRequest.url}. Retrying in ${delay}ms... (attempt ${originalRequest._retryCount}/3)`
        );
        
        await new Promise(resolve => setTimeout(resolve, delay));
        return MainApi(originalRequest);
      } else {
        console.warn(
          `API rate limit exceeded for ${originalRequest.url} after 3 retries. Request failed.`
        );
      }
    }
    
    return Promise.reject(error);
  }
);

export default MainApi;
